<svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 318 318">
  <defs>
    <style>
      .st0 {
        opacity: .8;
      }

      .st1 {
        opacity: .7;
      }

      .st2 {
        opacity: .5;
      }

      .st3 {
        opacity: .6;
      }

      .st4 {
        opacity: .2;
      }

      .st5 {
        opacity: .1;
      }

      .st6 {
        opacity: 0;
      }
    </style>
  </defs>
  <circle cx="159" cy="38.2" r="31.6"/>
  <circle class="st2" cx="159" cy="279.8" r="31.6"/>
  <circle class="st5" cx="279.8" cy="159" r="31.6"/>
  <circle class="st1" cx="38.2" cy="159" r="31.6"/>
  <circle class="st6" cx="244.5" cy="73.5" r="31.6"/>
  <circle class="st3" cx="73.5" cy="244.5" r="31.6"/>
  <circle class="st4" cx="244.5" cy="244.5" r="31.6"/>
  <circle class="st0" cx="73.5" cy="73.5" r="31.6"/>
</svg>